import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { usePrintsOrderStore } from '../stores';

const PhotoUndoRemovalButton = ({ disabled }) => {
  const removedPhotosExist = usePrintsOrderStore(
    (state) => state.removedPhotos.length > 0,
  );
  const undoLastRemove = usePrintsOrderStore(
    (state) => state.undoLastRemove,
  );

  return (
    <button
      className={classNames(
        'btn btn-link btn-underline px-0 text-lg-left text-right',
        {
          'text-muted': disabled || !removedPhotosExist,
        },
      )}
      role="button"
      disabled={disabled || !removedPhotosExist}
      onClick={undoLastRemove}>
      Undo Last Removal
    </button>
  );
};

PhotoUndoRemovalButton.propTypes = {
  disabled: PropTypes.bool,
};

PhotoUndoRemovalButton.defaultProps = {
  disabled: false,
};
export default PhotoUndoRemovalButton;
